// extracted by mini-css-extract-plugin
module.exports = {"Header":"ChatWindow_Header__1d6e-","Phone":"ChatWindow_Phone__2vY_L"};